
import logger from './logger';
import exponentialBackoff from './exponentialBackoff';

export function eaCollectorWrapper(params) {
    logger({EA: params});
    exponentialBackoff(
        () => !!window.EA_push,
        12,
        50,
        () => {
        window.EA_push(params);
        }
    );
}

export function dataLayerGAWrapper(params) {
    logger({GTM: params});
    setTimeout(function () {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push(params);
        }
    }, 2000);
}
